export const SERVICES = [
  { id: "print_only", label: "Print only", short: "Print only", hint: "You collect the transfer and press it yourself." },
  { id: "press_own", label: "Print & press on your garments", short: "Press on customer garments", hint: "Bring your own shirts or blanks — we press each design on for a small fee per garment." },
  { id: "press_merch", label: "Print & press on Merch", short: "Press on Merch", hint: "Pressed onto garments you buy from us — pressing included in the merch price." },
];
export const serviceMeta = (id) => SERVICES.find((s) => s.id === id) || SERVICES[0];
export const serviceLabel = (it) => {
  if (!it?.service) return null;
  const m = serviceMeta(it.service);
  if (it.service === "press_own") return `${m.short} ×${it.press_qty || 0}${it.press_fee ? ` @ $${Number(it.press_fee).toFixed(2)}` : ""}`;
  return m.short;
};
export const lineUnitPrice = (basePrice, service, pressQty, pressFee) => service === "press_own" ? +(basePrice + (Number(pressQty) || 0) * (Number(pressFee) || 0)).toFixed(2) : +Number(basePrice).toFixed(2);
